export default {
  name: 'request',
  data () {
    return {
      label: 'REQUEST',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/request/script.js